import * as React from 'react'
import {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartSeriesLabels,
    ChartTooltip
} from '@progress/kendo-react-charts';

import dashboardService from "../Service/DataService";
import withValueField from '../../Shared/withValueField';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { IDropDownModel } from '../../Shared/Models/IDropDownModel';
import { DashboardDropDownFilter, DashboardDropDownFilterIds, DashboardDropDownFilterValues } from '../../Shared/AppConstants';
import { ShimmerEffectCircleChartCandidate } from '../../ReusableComponents';
import DashboardIcons from '../DashboardIcons';
import { downloadExcel, successToastr } from '../../../HelperMethods';
import { EXCEL_DOWNLOAD_SUCCESS_MSG } from '../../Shared/AppMessages';
import { toolTip } from '../GlobalActions';

const CustomDropDownList = withValueField(DropDownList);

export interface CandidateChartProps {

}
export interface CandidateChartState {
    data?: any;
    originalData?: any;
    clientId?: any;
    vendorId?: any;
    user?: any;
    firstLoad?: any;
    filter?: Array<IDropDownModel>;
    filterId?: string;
    filterValue?: string;
    totalCount: number;
    segmentGap: number;
    segmentWidth: number;
    legendLabelOffsetX: any;
}

export default class CandidateChartContainer extends React.Component<CandidateChartProps, CandidateChartState> {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            totalCount: 0,
            segmentGap: 0,
            segmentWidth: 0,
            legendLabelOffsetX: this.getOffSetValue(window.innerWidth),
            firstLoad: true,
            filter: DashboardDropDownFilter,
            filterId: DashboardDropDownFilterIds.YEARTODATE,
            filterValue: DashboardDropDownFilterValues.YEARTODATE
        }
        this.updateHoleSize = this.updateHoleSize.bind(this);
    }

    componentDidMount() {
        this.getCandWfChart(this.state.filterValue);
        window.addEventListener('resize', this.updateHoleSize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateHoleSize);
    }

    updateHoleSize() {
        this.setState({
            legendLabelOffsetX: this.getOffSetValue(window.innerWidth)
        });
    }

    getCandWfChart(filterValue) {
        this.setState({ firstLoad: true });
        dashboardService.getCandWfChart(filterValue).then((res: any) => {
            this.setState({
                data: JSON.parse(res.data[0].status),
                totalCount: res.data[0].totalCount,
                segmentGap: res.data[0].totalCount === "1" ? 0 : 5,
                segmentWidth: res.data[0].totalCount === "1" ? 10 : 13,
                firstLoad: false,
            }, () => this.manipulateData(JSON.parse(res.data[0].status), res.data[0].totalCount));
        });
    }

    manipulateData = (data, totalValue) => {
        let data1 = data.map(item => {
            let share = item.value / totalValue;
            if (share < 0.01) {
                return {
                    ...item,
                    oldValue: item.value,
                    value: 0.01 * totalValue,
                    valueIncreased: true
                };
            }
            return item;
        });
        this.setState({
            data: data1
        })
    }

    getCandWfChartDate(filterValue) {
        dashboardService.getCandWfChartData(filterValue).then((res: any) => {
            if (res) {
                downloadExcel("Candidate Workflow.xlsx", res.data);
                successToastr(EXCEL_DOWNLOAD_SUCCESS_MSG);
            }
        });
    }

    handleFilterChange = (e) => {
        const id = e.value.id;
        const value = e.value.value;
        this.setState({ filterId: id, filterValue: value }, () => { this.getCandWfChart(value); });
    }

    donutCenterRenderer = () => (<div style={{ color: '#3B3B55' }}><h3><strong >{this.state.totalCount}</strong></h3><span className='fw-semiBold'>Total Candidates</span> </div>);

    renderTooltip = (context: any) => {
        const { dataItem, category, value } = context.point || context;
        let percent;

        if (dataItem.valueIncreased) {
            percent = parseFloat(((dataItem.oldValue / this.state.totalCount) * 100).toFixed(2))
            return (<div>{category} ({percent}%)</div>);
        }

        return (<div>{category} ({parseFloat(((value / this.state.totalCount) * 100).toFixed(2))}%)</div>);
    };

    getOffSetValue = (width) => {
        return width < 1290 ? -130
            : width < 1401 ? -150
                : width < 1537 ? -200
                    : width < 1681 ? -330
                        : width < 1710 ? -350
                            : width < 2000 ? -600
                                : width > 2559 ? -1200
                                    : -1200;
    }

    render() {
        const { firstLoad, data, segmentWidth, segmentGap, legendLabelOffsetX } = this.state;

        return (
            <div className=''>
                <div className='card card-radius p-4 mb-3'>

                    <div className='d-flex align-items-center justify-content-between mb-2'>
                        <h2 className='heading2 text-right mb-0 text-yellow'>Candidate</h2>
                        <div className='d-flex'>
                            <CustomDropDownList
                                className={"kpi-input-control month-to-date"}
                                data={this.state.filter}
                                name="name"
                                textField="name"
                                valueField="id"
                                id="filter"
                                value={this.state.filterId}
                                onChange={(e) => this.handleFilterChange(e)}
                            />
                            {toolTip(
                                <button className='ml-3 btn-transp icon-center icon-squire' onClick={() => this.getCandWfChartDate(this.state.filterValue)} title="Export">
                                    <img className='normal-icon' src={DashboardIcons.downloadIcon} />
                                    <img className='hover-icon' src={DashboardIcons.downloadIconHover} />
                                </button>
                            )}
                        </div>
                    </div>

                    {!firstLoad && data && this.state.totalCount == 0 ? <div className="font-weight-bold w-100 mx-auto text-center">No Records Found!</div> :
                        !firstLoad && data && this.state.totalCount > 0 ? <div>
                            <div className='col-12 candidateChart'>
                                <Chart
                                    donutCenterRender={this.donutCenterRenderer}
                                >
                                    <ChartTooltip render={this.renderTooltip} />
                                    <ChartSeries>
                                        <ChartSeriesItem
                                            autoFit={true}
                                            type="donut"
                                            data={data}
                                            categoryField="status"
                                            field="value"
                                            size={segmentWidth}
                                            holeSize={120}
                                            border={{ width: segmentGap, color: 'white' }}
                                            highlight={{
                                                inactiveOpacity: 0.2
                                            } as any
                                            }
                                        >
                                            <ChartSeriesLabels color="#fff" background="none" content={(e) => ""} />
                                        </ChartSeriesItem>
                                    </ChartSeries>
                                    <ChartLegend align={'center'} offsetX={legendLabelOffsetX} position='right' labels={{ font: "500 14px Arial, open-sans", margin: 1 }} visible={true} />
                                </Chart>
                            </div>
                        </div>
                            : ShimmerEffectCircleChartCandidate()
                    }
                </div>
            </div>
        )
    }
}